import { Button } from '@/components/ui/button'
import { Heading } from '@/components/ui/heading'
import { IconButton } from '@/components/ui/icon-button'
import { Text } from '@/components/ui/text'
import { AppTooltip } from '@components'
import { AppDrawer } from '@components/AppDrawer'
import LayoutHeader from '@components/LayoutHeader'
import { FilterButton } from '@components/PageSearch'
import { BookPlus } from 'lucide-solid'
import { createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Flex, Grid } from 'styled-system/jsx'
import { useCreate } from '../../Create/state'
import Filters from '../Filters'
import { useFilters } from '../state/filter'
import { SetupsSearch, useSetupsUrlSync } from './ActiveFilters'
import { LayoutSelector } from './LayoutSelector'
import Menu from './Menu'
import { ViewSelector } from './ViewSelector'

export function Header() {
  const [isFilterOpen, setIsFilterOpen] = createSignal(false)
  const { openCreateSetup } = useService(useCreate)()
  const { runFilters, activeFilterCount } = useService(useFilters)()
  useSetupsUrlSync()

  return (
    <LayoutHeader
      title='Setups'
      rightContent={<Flex
        gap={{ base: '2', mdDown: '1.5' }}
        alignItems="center"
        flexWrap="wrap"
        justifyContent="flex-end"
      >
        <SetupsSearch class={css({ w: '220px', display: { base: 'flex', lgDown: 'none' } })} />
        <ViewSelector />
        <Menu />
        <LayoutSelector />
        <AppDrawer
          size='md'
          open={isFilterOpen()}
          onOpenChange={({ open }) => setIsFilterOpen(open)}
          onExitComplete={runFilters}
          title="Filter Setup"
          trigger={
            <AppTooltip delay={900} content='Filter Setups'>
              <FilterButton count={activeFilterCount()} />
            </AppTooltip>
          }
        >
          <Filters setIsOpen={setIsFilterOpen} />
        </AppDrawer>
        <AppTooltip delay={900} content='Create New Setup'>
          <Button
            onClick={openCreateSetup}
            colorPalette="jade"
            variant="solid"
            size="sm"
          >
            <BookPlus />
            <Text
              display={{
                base: 'display',
                mdDown: 'none',
              }}
              children="New"
            />
          </Button>
        </AppTooltip>
      </Flex>}
    >

    </LayoutHeader>
  )
}
